import { httpRequest } from "@/axios/axios-api";

export default {
  data() {
    return {
      invoiceList: []
    };
  },
  created: function() {
    // 加载发票记录
    this.loadInvoiceList();
  },
  methods: {
    // 加载当前问题的统一方法
    async loadInvoiceList() {
      const loadingInstance = this.$loading({ text: "加载中" });
      const res = await httpRequest(
        "/app/invoice/invoice/invoices",
        "get",
        null
      );
      if (res !== null && res !== undefined && res.code === 200) {
        this.invoiceList = res.data;
      }
      loadingInstance.close();
    },
    go2InvoicePage(invoiceIdx) {
      const curInvoice = this.invoiceList[invoiceIdx];
      if (curInvoice.invoice === null) {
        // 去开票页面
        this.$router.push({
          path: "/applyInvoice",
          query: {
            arId: curInvoice.arId,
            price: curInvoice.realityPayMoney
          }
        });
      } else {
        // 去发票详情页面
        this.$router.push({
          path: "/invoiceDetail",
          query: { invoice: JSON.stringify(curInvoice.invoice) }
        });
      }
    }
  }
};
